// Bump this on every change, per the versioning rule in CLAUDE.md.
export const APP_VERSION = "1.0.1";
